// extracted by mini-css-extract-plugin
module.exports = {"navBar":"NavBarSwitch_navBar__3KSnK","navLink":"NavBarSwitch_navLink__1zVDq","navLink--active":"NavBarSwitch_navLink--active__33zoE"};